import { Component, computed, input } from '@angular/core';
import { ApiFinding } from 'api';
import { getDependencyTrackVulnerabilityData } from 'component/details/requirement-intake/requirements-detail/findings/list/findings-list.utils';
import { MatTooltip } from '@angular/material/tooltip';

interface CWE {
  readonly id: string;
  readonly short: string;
  readonly full: string;
  readonly url: string;
}

const CWE_ID_PATTERN = /CWE-(\d+)/i;

@Component({
  selector: 'comp-finding-cwes',
  templateUrl: 'cwes.component.html',
  imports: [MatTooltip],
})
export class CWEsComponent {
  readonly finding = input.required<ApiFinding>();

  protected readonly cweEntries = computed<ReadonlyArray<CWE>>(() => {
    const cwes = getDependencyTrackVulnerabilityData(this.finding())?.cwes ?? [];

    return cwes.map(CWEsComponent.asCWE);
  });

  private static asCWE(cweText: string): CWE {
    const id = CWEsComponent.getCweIdOnly(cweText);
    return {
      id: id,
      short: `CWE-${id}`,
      full: cweText,
      url: `https://cwe.mitre.org/data/definitions/${id}.html`,
    };
  }

  private static getCweIdOnly(cweText: string): string {
    const cweId = cweText.match(CWE_ID_PATTERN);

    if (!cweId?.length) {
      return cweText;
    }

    return cweId[1];
  }
}
